import { Button, PageState } from '@deepdive-ui';
import { isRouteErrorResponse, useRouteError } from 'react-router';

import { reportError } from '@/services/errorReporting';

/** A route's `errorElement`: a render/loader error never blanks the whole app. */
export function RouteError() {
  const error = useRouteError();
  if (isRouteErrorResponse(error) && error.status === 404) {
    return <PageState title="Page not found" description="The page you’re looking for doesn’t exist." />;
  }
  reportError(error, { boundary: 'route' });
  return (
    <PageState
      role="alert"
      title="Something went wrong"
      description="This page hit an unexpected error. Reloading usually fixes it."
      actions={
        <Button hierarchy="primary" onClick={() => window.location.reload()}>
          Reload
        </Button>
      }
    />
  );
}
